/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellular0Bar: {
  name: 'signal-cellular-0-bar';
  data: string;
} = {
  name: 'signal-cellular-0-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 22h20V2L2 22zm18-2H6.83L20 6.83V20z"/></svg>`
};
